import { createSlice } from "@reduxjs/toolkit";
import {
    getMyExpenses, getAllExpenses, getExpensesForApprover, createNewExpense, approveExpense, deleteExpense, submitExpensesForApproval, markExpenseAsPaid
} from './thunk';

export const initialState = {
    myExpensesList: [],
    allExpensesList: [],
    expensesForApprover: [],
    errors: {}
};

const ExpensesSlice = createSlice({
    name: 'Expenses',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // Get my expenses
        builder.addCase(getMyExpenses.fulfilled, (state: any, action: any) => {
            console.log('getMyExpenses fulfilled payload:', action.payload);
            // Handle different response structures
            if (Array.isArray(action.payload)) {
                state.myExpensesList = action.payload;
            } else if (action.payload?.data) {
                state.myExpensesList = Array.isArray(action.payload.data) ? action.payload.data : [];
            } else if (action.payload?.status && action.payload?.data) {
                state.myExpensesList = Array.isArray(action.payload.data) ? action.payload.data : [];
            } else {
                state.myExpensesList = [];
            }
        });
        builder.addCase(getMyExpenses.rejected, (state: any, action: any) => {
            console.error('getMyExpenses rejected:', action);
            state.error = action.payload?.error || action.error?.message || action.payload || null;
            state.myExpensesList = [];
        });
        
        // Get all expenses
        builder.addCase(getAllExpenses.fulfilled, (state: any, action: any) => {
            state.allExpensesList = action.payload?.data || action.payload || [];
        });
        builder.addCase(getAllExpenses.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || action.error?.message || null;
        });
        
        // Get expenses for approver
        builder.addCase(getExpensesForApprover.fulfilled, (state: any, action: any) => {
            console.log('getExpensesForApprover fulfilled payload:', action.payload);
            // Handle different response structures
            if (Array.isArray(action.payload)) {
                state.expensesForApprover = action.payload;
            } else if (action.payload?.data) {
                state.expensesForApprover = Array.isArray(action.payload.data) ? action.payload.data : [];
            } else if (action.payload?.status && action.payload?.data) {
                state.expensesForApprover = Array.isArray(action.payload.data) ? action.payload.data : [];
            } else {
                state.expensesForApprover = [];
            }
        });
        builder.addCase(getExpensesForApprover.rejected, (state: any, action: any) => {
            console.error('getExpensesForApprover rejected:', action);
            state.error = action.payload?.error || action.error?.message || action.payload || null;
            state.expensesForApprover = [];
        });
        
        // Create new expense
        builder.addCase(createNewExpense.fulfilled, (state: any, action: any) => {
            state.error = null;
        });
        builder.addCase(createNewExpense.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || action.error?.message || 'Failed to create expense request';
        });
        
        // Approve expense
        builder.addCase(approveExpense.fulfilled, (state: any, action: any) => {
            state.error = null;
        });
        builder.addCase(approveExpense.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || action.error?.message || 'Failed to approve expense';
        });
        
        // Delete expense
        builder.addCase(deleteExpense.fulfilled, (state: any, action: any) => {
            state.error = null;
        });
        builder.addCase(deleteExpense.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || action.error?.message || 'Failed to delete expense';
        });
        
        // Submit expenses for approval
        builder.addCase(submitExpensesForApproval.fulfilled, (state: any, action: any) => {
            state.error = null;
        });
        builder.addCase(submitExpensesForApproval.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || action.error?.message || 'Failed to submit expenses for approval';
        });
        
        // Mark expense as paid
        builder.addCase(markExpenseAsPaid.fulfilled, (state: any, action: any) => {
            state.error = null;
        });
        builder.addCase(markExpenseAsPaid.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || action.error?.message || 'Failed to mark expense as paid';
        });
    }
});

export default ExpensesSlice.reducer;

